import { __extends } from "tslib";
import { ErrorBase } from '@awayjs/core';
var CastError = /** @class */ (function (_super) {
    __extends(CastError, _super);
    function CastError(message) {
        return _super.call(this, message) || this;
    }
    return CastError;
}(ErrorBase));
export { CastError };
